import { useCallback, useEffect, useRef, useState } from "react";
import { Camera, CameraOff, ScanLine } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { inputCls, btnPrimary, useApi } from "@/components/portal/ui";
import { AdminTitle } from "@/pages/admin/AdminLayout";
import { QrScanner } from "@/components/portal/QrScanner";

export default function Checkin() {
  const { data: schedules } = useApi("/admin/r/schedules");
  const [scheduleId, setScheduleId] = useState("");
  const [nig, setNig] = useState("");
  const [camera, setCamera] = useState(false);
  const { data: today, reload } = useApi("/admin/checkins");

  useEffect(() => {
    if (schedules?.length && !scheduleId) setScheduleId(schedules[0].id);
  }, [schedules, scheduleId]);

  const submit = async (value) => {
    if (!value) return;
    try {
      const { data } = await api.post("/admin/checkins", { nig: value, schedule_id: scheduleId });
      toast.success(`${data.name} berhasil check-in`);
      setNig("");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const submitRef = useRef(submit);
  submitRef.current = submit;
  const onScan = useCallback((v) => submitRef.current(v), []);

  return (
    <div data-testid="admin-checkin">
      <AdminTitle eyebrow="Kehadiran" title="Check-in QR" />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-slate-100 space-y-4">
          <label className="block"><span className="text-xs font-bold text-slate-500 uppercase tracking-wider">Ibadah</span>
            <select data-testid="checkin-schedule-select" className={`${inputCls} mt-2`} value={scheduleId} onChange={(e) => setScheduleId(e.target.value)}>
              {(schedules || []).map((s) => <option key={s.id} value={s.id}>{`${s.title} · ${s.day} ${s.time}`}</option>)}
            </select>
          </label>
          <form onSubmit={(e) => { e.preventDefault(); submit(nig.trim()); }} className="flex gap-2">
            <input data-testid="checkin-nig-input" className={inputCls} placeholder="Masukkan NIG (contoh 26091001)" value={nig} onChange={(e) => setNig(e.target.value)} />
            <button data-testid="checkin-submit-button" className={btnPrimary}><ScanLine className="w-4 h-4" /></button>
          </form>
          <button type="button" onClick={() => setCamera(!camera)} data-testid="checkin-camera-toggle" className="w-full inline-flex items-center justify-center gap-2 border border-slate-200 rounded-xl py-3 font-bold text-slate-700 hover:bg-slate-50 active:scale-95 transition">
            {camera ? <><CameraOff className="w-4 h-4" />Matikan Kamera</> : <><Camera className="w-4 h-4" />Scan QR dengan Kamera</>}
          </button>
          {camera && <QrScanner onScan={onScan} testId="qr-reader" transform={(t) => t.replace(/^GIM:/, "")} />}
        </div>
        <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-slate-100" data-testid="checkin-today-list">
          <div className="flex items-center justify-between"><p className="font-extrabold text-slate-900">Hadir Hari Ini</p><span className="text-[11px] font-bold bg-blue-100 text-blue-700 rounded-full px-3 py-1">{today?.length || 0} jemaat</span></div>
          <div className="mt-4 divide-y divide-slate-100">
            {(today || []).map((c) => (
              <div key={c.id} className="py-3 flex items-center justify-between">
                <div><p className="font-semibold text-sm text-slate-900">{c.name}</p><p className="text-xs text-slate-500">{c.schedule_title}</p></div>
                <span className="text-xs font-bold tabular-nums text-slate-600">{c.nig} · {new Date(c.created_at).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" })}</span>
              </div>
            ))}
            {today?.length === 0 && <p className="py-6 text-sm text-slate-500">Belum ada check-in.</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
